import { useState, useEffect, Fragment } from "react";
import InfoHeader from "../components/InfoHeader";
import PopularCurrencies from "../components/PopularCurrencies";
import OtherCurrencies from "../components/OtherCurrencies";
import Coins from "../components/Coins";

import { io } from "socket.io-client";

const MainPage = () => {
  const { REACT_APP_URL } = process.env;
  // states
  const [loading, setLoading] = useState(true);
  const [currencies, setCurrencies] = useState([]);
  const [coins, setCoins] = useState([]);
  const [infos, setInfos] = useState([]);

  useEffect(() => {
    const socket = io(`${REACT_APP_URL}/api/socket`, {
      transports: ["websocket"],
    });

    socket.on("connect", () => {
      console.log("Connected to server");
    });

    socket.on("disconnect", () => {
      console.log("Disconnected from server");
    });

    socket.on("error", (error) => {
      console.error("Socket error:", error);
    });

    socket.on("getCurrencies", (data) => {
      // console.log("currency", data);
      setCurrencies(data);
    });
    socket.on("getCoins", (data) => {
      // console.log("coin", data);
      setCoins(data);
    });
    socket.on("msg", (data) => {
      // console.log("msg", data);
      setInfos(data);
    });

    const getCurrencies = async () => {
      try {
        const currRes = await fetch(`${REACT_APP_URL}/api/getallcurrencies`, {
          method: "POST",
        });
        const currData = await currRes?.json();
        setCurrencies(currData);

        const coinRes = await fetch(`${REACT_APP_URL}/api/getallcoins`, {
          method: "POST",
        });
        const coinData = await coinRes?.json();
        setCoins(coinData);
        setLoading(false);
      } catch (err) {
        console.log(err);
      }
    };

    const getInfos = async () => {
      try {
        const res = await fetch(`${REACT_APP_URL}/api/getmsg`, {
          method: "POST",
        });
        const data = await res?.json();
        setInfos(data.msg);
      } catch (err) {
        console.log(err);
      }
    };

    // const getImageSlides = async () => {
    //   try {
    //     fetch(`${REACT_APP_URL}/api/getImageName`)
    //       .then((res) => {
    //         return res.json();
    //       })
    //       .then((data) => {
    //         setImages(data.data);
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    //   } catch (err) {
    //     console.log(err);
    //   }
    // };

    getCurrencies();
    getInfos();
    // getImageSlides();
  }, []);

  return (
    <Fragment>
      <InfoHeader infos={infos} />
      {/* {images && images.length !== 0 && <ImageSlider images={images} />} */}
      <PopularCurrencies currencies={currencies} isLoading={loading} />
      <OtherCurrencies currencies={currencies} isLoading={loading} />
      <Coins coins={coins} isLoading={loading} />
    </Fragment>
  );
};
export default MainPage;
